import React from 'react';
import type { FormikProps } from 'formik';

export type RegulationsFormikRef = React.MutableRefObject<FormikProps<any> | null>;

const RegulationsFormikRefContext = React.createContext<RegulationsFormikRef | null>(null);

export const RegulationsFormikRefProvider = RegulationsFormikRefContext.Provider;

export const useRegulationsFormikRef = (): RegulationsFormikRef => {
  const ref = React.useContext(RegulationsFormikRefContext);

  if (!ref) {
    throw new Error('useRegulationsFormikRef must be used within a RegulationsFormikRefProvider');
  }

  return ref;
};
